export default "__VITE_ASSET__B91$Um0h__"